// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__2wbFm","content":"GlobalSearch_content__lAxt8"};